module.exports = __webpack_public_path__ + "img/Physician - Pink.7b18d249.png";